import { TThemeColor } from './types';
import tailwindConfig from '../tailwind.config';

const { colors: baseColors } = tailwindConfig.theme;
const { colors: extendedColors } = tailwindConfig.theme.extend;

export const getThemeHex = (): TThemeColor => {
  return {
    primary10: extendedColors.primary[10],
    primary20: extendedColors.primary[20],
    primary40: extendedColors.primary[40],
    primary60: extendedColors.primary[60],
    primary80: extendedColors.primary[80],
    primary100: extendedColors.primary[100],
    primary110: extendedColors.primary[110],
    neutral10: baseColors.neutral[10],
    neutral20: baseColors.neutral[20],
    neutral40: baseColors.neutral[40],
    neutral60: baseColors.neutral[60],
    neutral80: baseColors.neutral[80],
    neutral100: baseColors.neutral[100],
    neutral110: baseColors.neutral[110],
    neutral120: baseColors.neutral[120],
    neutral140: baseColors.neutral[140],
    red40: baseColors.red[40],
    red60: baseColors.red[60],
    red80: baseColors.red[80],
    red100: baseColors.red[100],
    green80: baseColors.green[80],
    green100: baseColors.green[100],
    orange40: baseColors.orange[40],
    orange80: baseColors.orange[80],
    orange100: baseColors.orange[100],
    white: baseColors.white,
  };
};

export const getThemeColorHex = (property: keyof TThemeColor) => {
  return getThemeHex()[property];
};
